import { makeStyles } from '@material-ui/styles';

const styles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
  },
  textField: {
    '& > .MuiInputBase-root': {
      marginBottom: 16,
    },
    '& > .Mui-error': {
      marginBottom: 0,
    },
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
}));

export default styles;
